// import Form from "@components/shared/form";
import ProsConsList from "@components/shared/prosConsList";
import styles from "./style.module.scss";
import VendorOffer from "@components/shared/vendorOffer";
import { useQuery } from "@tanstack/react-query";
import { GQLOffers, GQLOfferFeatures, GQLCategories } from "@gql/types/gql";
import {
    addNoFollowToLinks,
    PLACE_HOLDER_IMAGE_PATH,
    titleDecoder,
} from "@lib/sharedUtils";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";

import Image from "next/legacy/image";
import { Session } from "pages/api/session";
export default function Introduction({ vendor }: { vendor: GQLOffers }) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { data: session } = useQuery<Session>(["session"]);
    const { data: categoryId } = useQuery<number>(["categoryId"]);
    const { data: category } = useQuery<GQLCategories>([
        "categoryById",
        categoryId?.toString(),
    ]);

    const discountValue = vendor?.attributes?.find(
        (attr) => attr?.baseAttribute?.name === "discountValue",
    )?.value;
    return (
        <section className="relative">
            {vendor && discountValue && (
                <span className={styles["badge"]}>
                    {translate(translations, "several_general-DiscountWord")}{" "}
                    {`${discountValue}%`}
                </span>
            )}
            <div
                className={`lg:mt-4 mt-6 ${styles.offerMainImage}`}
                itemProp="image"
            >
                {vendor?.mainImage?.fullPath ? (
                    <div className={` relative w-full  ${styles.mainImage}`}>
                        <Image
                            src={vendor?.mainImage?.fullPath}
                            alt={vendor?.title as string}
                            width={844}
                            height={538}
                            priority
                            itemProp="image"
                            className="block w-full"
                            sizes="(max-width: 768px) 100vw,
                                (max-width: 1200px) 50vw,
                                60vw"
                        />
                        {vendor?.mainImage?.caption && (
                            <div
                                className={`text-gray-500 text-sm bg-[#fffcf1] px-2 py-1`}
                            >
                                {vendor?.mainImage?.caption}
                            </div>
                        )}
                    </div>
                ) : (
                    <>
                        <img
                            src={PLACE_HOLDER_IMAGE_PATH}
                            width={844}
                            height={538}
                            alt="category image"
                        />
                    </>
                )}
            </div>
            <div
                dangerouslySetInnerHTML={{
                    __html: addNoFollowToLinks(
                        titleDecoder(vendor.overview as string, {
                            category: category?.name as string,
                            region: session?.visitDetails?.region,
                        }),
                    ),
                }}
                className="offerContainer"
            />
            <div className="mt-12 flex flex-col lg:flex-row   lg:gap-20 gap-7 ">
                <div className=" lg:w-1/2 w-full">
                    {(vendor?.pros?.length ?? 0) > 0 && (
                        <ProsConsList
                            list={vendor?.pros as GQLOfferFeatures[]}
                        />
                    )}
                </div>
                <div className=" lg:w-1/2 w-full">
                    {(vendor?.cons?.length ?? 0) > 0 && (
                        <ProsConsList
                            list={vendor?.cons as GQLOfferFeatures[]}
                        />
                    )}
                </div>
            </div>
            <VendorOffer
                buyer={vendor}
                categoryId={vendor?.categories?.[0]?.id as number}
                vendorShow={true}
            />
        </section>
    );
}
